export default __webpack_public_path__ + "static/7-ba261b2225f03c260bfe412c3faddb66.jpg";